import { render, staticRenderFns } from "./jingjiadating.vue?vue&type=template&id=0413660c&scoped=true"
import script from "./jingjiadating.vue?vue&type=script&lang=js"
export * from "./jingjiadating.vue?vue&type=script&lang=js"
import style0 from "./jingjiadating.vue?vue&type=style&index=0&id=0413660c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413660c",
  null
  
)

export default component.exports